import type { CustomDataArtifact } from '@dev-streetbeat/chat';

/**
 * Portfolio extraction utilities for SDK artifacts
 */

export interface PortfolioExtractionResult {
    portfolioData: any | null;
    portfolioId: string | null;
    commentoAlPortafoglio: boolean;
}

/**
 * Checks if an artifact is a Fineco portfolio custom_data artifact
 */
export function isFinecoPortfolioArtifact(artifact: any): artifact is CustomDataArtifact {
    return (
        artifact?.type === "custom_data" &&
        artifact.custom_data?.type === "fineco_portfolio" &&
        artifact.custom_data?.data != null
    );
}

/**
 * Extracts portfolio data from SDK CustomDataArtifact format
 */
export function getPortfolioData(artifact: any): any | null {
    if (isFinecoPortfolioArtifact(artifact)) {
        const data = artifact.custom_data.data as any;
        return data?.data || null;
    }
    return null;
}

/**
 * Extracts portfolio ID from SDK CustomDataArtifact format
 */
export function getPortfolioId(artifact: any): string | null {
    if (isFinecoPortfolioArtifact(artifact)) {
        const data = artifact.custom_data.data as any;
        return data?.portfolio_id || null;
    }
    return null;
}

/**
 * Extracts commento_al_portafoglio flag from SDK CustomDataArtifact format
 */
export function getCommentoAlPortafoglio(artifact: any): boolean {
    if (isFinecoPortfolioArtifact(artifact)) {
        const data = artifact.custom_data.data as any;
        return data?.commento_al_portafoglio || false;
    }
    return false;
}

/**
 * Extracts all portfolio-related data from an artifact in one call
 */
export function extractPortfolioFromArtifact(artifact: any): PortfolioExtractionResult {
    return {
        portfolioData: getPortfolioData(artifact),
        portfolioId: getPortfolioId(artifact),
        commentoAlPortafoglio: getCommentoAlPortafoglio(artifact),
    };
}

/**
 * Checks if an artifact is a portfolio story custom_data artifact
 */
export function isPortfolioStoryArtifact(artifact: any): artifact is CustomDataArtifact {
    return (
        artifact?.type === "custom_data" &&
        artifact.custom_data?.type === "portfolio_story" &&
        artifact.custom_data?.data != null
    );
}
